import { Typography, CardActions, Checkbox } from '@mui/material';
import React from 'react';
import BookingStatusInfo from '../BookingStatusInfo';
import { BookingStatus, getTime, GroupedBookings } from '../utils';
import {
  BookingCardHeader,
  BookingCardButton,
  BookingCardContent,
  BookingCardWrapper,
} from './BookingCard.styled';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

export interface BookingCardProps {
  bookingsGroup: GroupedBookings;
  selected: boolean;
  toggleSelection: () => void;
  selectionMode: boolean;
  handleOpenDoorClick: () => void;
  index?: number;
}

const BookingCard = ({
  bookingsGroup,
  selected,
  toggleSelection,
  selectionMode,
  handleOpenDoorClick,
  index,
}: BookingCardProps) => {
  const startTime = getTime(bookingsGroup.start_time);
  const endTime = getTime(bookingsGroup.end_time);

  return (
    <BookingCardWrapper
      sx={{ borderColor: selected ? '#5f51a6' : 'transparent' }}
      elevation={5}
      onClick={toggleSelection}
    >
      <BookingCardContent sx={{ padding: 1 }}>
        <BookingCardHeader>
          {bookingsGroup.booking_status === BookingStatus.Success && (
            <Checkbox
              checked={selected}
              icon={<CircleOutlinedIcon />}
              checkedIcon={<CheckCircleOutlineOutlinedIcon />}
              sx={{ opacity: selectionMode ? 1 : 0, padding: 0, transition: 'all 0.4s ease' }}
              disabled={!selected}
            />
          )}

          <BookingStatusInfo
            small
            status={bookingsGroup.booking_status}
            index={index}
          />
        </BookingCardHeader>
        <Typography
          variant='h5'
          component='div'
        >
          {startTime} - {endTime}
        </Typography>
        <Typography
          sx={{ mb: 1.5 }}
          color='text.secondary'
        >
          {`Стол ${bookingsGroup.table_number}`}
        </Typography>
      </BookingCardContent>
      {bookingsGroup.booking_status === 'Success' && (
        <>
          <CardActions sx={{ display: 'flex', justifyContent: 'center' }}>
            <BookingCardButton
              variant='contained'
              onClick={(event) => {
                event.stopPropagation();
                handleOpenDoorClick();
              }}
            >
              Войти в зал
            </BookingCardButton>
          </CardActions>
        </>
      )}
    </BookingCardWrapper>
  );
};

export default BookingCard;
